import { Sprout, Hammer, Flame, LucideIcon } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { IDifficulty } from '@/redux/post/post.d';

const DIFFICULTY_META: Record<string, { Icon: LucideIcon; tone: string }> = {
  [IDifficulty.BEGINNER]: { Icon: Sprout, tone: 'text-success' },
  [IDifficulty.ADVANCED]: { Icon: Hammer, tone: 'text-warning' },
  [IDifficulty.EXPERT]: { Icon: Flame, tone: 'text-destructive' },
};

export default function DifficultyBadge({
  difficulty,
  className = '',
}: {
  difficulty?: string | null;
  className?: string;
}) {
  const meta = difficulty ? DIFFICULTY_META[difficulty] : undefined;
  if (!meta) return null;
  return (
    <Badge
      variant="secondary"
      className={`gap-1.5 rounded-full px-3 py-1 font-medium capitalize border border-border ${className}`}
    >
      <meta.Icon className={`h-3.5 w-3.5 ${meta.tone}`} />
      {difficulty}
    </Badge>
  );
}
